import script from "./HeaderTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTitle.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTitle.vue?vue&type=style&index=0&id=a02a198a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a02a198a"]])

export default __exports__